import { Component, OnInit, Output, EventEmitter, Input, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NbDialogService } from '@nebular/theme';
import { CookieService } from 'ngx-cookie-service';
import * as _ from 'lodash';
import { TranslationService } from '../../language/translation.service';

@Component({
  selector: 'app-select-product',
  templateUrl: './select-product.component.html',
  styleUrls: ['./select-product.component.scss']
})
export class SelectProductComponent implements OnInit, OnDestroy {
  @Output() emitClose = new EventEmitter();
  @Output() emitList = new EventEmitter();
  @Input() orgData: Array<any>;
  @Input() info: {
    IsLoding: boolean,
    ORG_Store_ID: string,
    PRD_PlatformType_ID: number,
    EditDisposablesMo: any,
  };

  @Input() ProductList: Array<any>;

  modalRef = null;
  PdModalRef = null;
  languageChangeSub: any;

  @ViewChild('Modal') Modal: TemplateRef<any>;
  @ViewChild('PdModal') PdModal: TemplateRef<any>;

  selectData: Array<any>;
  mainDataList: Array<any>;
  showList: Array<any>;
  showListPd: Array<any>;
  query = {
    searchKey: "",
    ORG_Company_ID: null,
    ORG_Store_ID: null,
  };
  status = {
    isSelectAll: false,
    AllSelectCount: 0,
    showType: null,
  };

  storeSelectList: selectData[];
  selectORG_Store_ID: number;
  PRD_PlatformType_ID: number;

  constructor(
    private dialogService: NbDialogService,
    private http: HttpClient,
    private cookieService: CookieService,
    private translationService: TranslationService,
  ) {
    const cookieSid = this.cookieService.get('ORG_Store_ID');
    this.query.ORG_Store_ID = cookieSid && cookieSid != '' ? parseInt(cookieSid) : null;
    this.query.ORG_Company_ID = parseInt(this.cookieService.get('ORG_Company_ID'));
  }

  ngOnInit(): void {
    this.languageChangeSub = this.translationService.languageChanged$.subscribe(() => {});
  }

  ngOnDestroy() {
    if (this.languageChangeSub) {
      this.languageChangeSub.unsubscribe();
    }
  }

  ngAfterViewInit() {
    this.onOpen(this.info, this.orgData);
  }

  getStoreList(fun) {
    this.http.post<any>('api/ORGStore/StoreList', {
      ORG_Company_ID: this.query.ORG_Company_ID,
      ORG_Store_ID: this.query.ORG_Store_ID,
    }).subscribe({
      next: data => {
        this.storeSelectList = [];

        let item: any = {};
        item.value = 0;
        item.content = this.t('common_head_office', '總部');
        this.storeSelectList.push(item);

        if (this.query.ORG_Store_ID) {
          item = {};
          item.value = this.query.ORG_Store_ID;
          item.content = data.LIST.find(x => x.ORG_Store_ID == this.query.ORG_Store_ID).StoreName;
          this.storeSelectList.push(item);
        } else {
          data.LIST.forEach(element => {
            const selectItem = new selectData();
            selectItem.value = element.ORG_Store_ID;
            selectItem.content = element.StoreName;
            this.storeSelectList.push(selectItem);
          });
        }

        if (this.storeSelectList.length > 0) {
          this.selectORG_Store_ID = this.storeSelectList[0].value;
        }

        if (fun) {
          fun();
        }
      },
      error: error => {
        console.error('There was an error!', error);
      }
    });
  }

  onOpen(info, useData) {
    if (info) {
      this.info = info;
      this.PRD_PlatformType_ID = this.info.PRD_PlatformType_ID;
    }

    this.mainDataList = [];
    this.selectData = [];

    if (useData && useData.length) {
      this.selectData = _.cloneDeep(useData);
    }

    this.getStoreList(() => {
      this.getProductList((data) => {
        this.showData(data, useData);
      });
    });

    this.modalRef = this.dialogService.open(this.Modal, {});
    this.modalRef.onClose.subscribe(() => {
      this.emitClose.emit(true);
    });
  }

  showData(data, useData) {
    const useDataAll = [];
    if (useData != null && useData.length > 0) {
      useData.forEach(k => useDataAll.push(k.No));
    }
    let all = [];
    if (this.info.EditDisposablesMo != null) {
      this.info.EditDisposablesMo.disposablesRuleReqs.forEach(k => {
        if (k.PorductData != null) {
          k.PorductData.forEach(l => all.push(l.PRDProductNo));
        }
      });
      all = all.filter(item => !useDataAll.includes(item));
    }

    const ProductList = [];
    const list = _.groupBy(data.LIST, 'GroupNo');
    const key = _.keys(list);
    key.forEach(k => {
      const obj = new ProductGroup();
      obj.CreateStoreName = list[k][0].CreateStoreName;
      obj.GroupNo = k;
      obj.GroupName = list[k][0].GroupName;
      obj.PDList = _.concat([], list[k]);
      obj.PDList = obj.PDList.filter(item => !all.includes(item.No));
      obj.IsOK_Group = false;
      ProductList.push(obj);
    });

    this.mainDataList = ProductList;

    if (useData) {
      this.mainDataList.forEach(g => {
        g.PDList.forEach(p => {
          const pd = _.find(useData, a => a.No == p.No);
          if (pd) {
            pd.GroupNo = p.GroupNo;
            p = _.assign(p, pd);
            p.IsOK_Product = true;
            g.IsOK_Group = p.IsOK_Product;
          }
        });

        g.IsOK_Product_Count(this.t('common_confirm_selection', '已選'));
        this.sumSelect();
      });
    }
  }

  onQuery() {
    this.getProductList((data) => {
      const useData = [];
      this.selectData.forEach(y => {
        useData.push({ GroupNo: y.GroupNo, No: y.No });
      });
      this.showData(data, useData);
    });
  }

  AddSelectData(pd, isSelect) {
    if (isSelect) {
      if (!_.find(this.selectData, a => a.No == pd.No)) {
        this.selectData.push(pd);
      }
    } else {
      _.remove(this.selectData, x => x.No == pd.No);
    }
  }

  onSelectAllG() {
    this.mainDataList.forEach(group => {
      group.IsOK_Group = this.status.isSelectAll;
      _.forEach(group.PDList, p => {
        p.IsOK_Group = group.IsOK_Group;
        p.IsOK_Product = group.IsOK_Group;
        this.AddSelectData(p, group.IsOK_Group);
      });
      group.IsOK_Product_Count(this.t('common_confirm_selection', '已選'));
    });
    this.sumSelect();
  }

  sumSelect() {
    let selectCount = 0;
    let allcount = 0;
    this.mainDataList.forEach(group => {
      selectCount += group.CountSum;
      allcount += group.PDList.length;
    });

    this.status.AllSelectCount = selectCount;
    this.status.isSelectAll = (selectCount == allcount);
  }

  onSelectG(GID) {
    const group = _.find(this.mainDataList, a => a.GroupNo == GID);
    if (group) {
      _.forEach(group.PDList, p => {
        p.IsOK_Group = group.IsOK_Group;
        p.IsOK_Product = group.IsOK_Group;
        this.AddSelectData(p, group.IsOK_Group);
      });
      group.IsOK_Product_Count(this.t('common_confirm_selection', '已選'));
    }
    this.sumSelect();
  }

  onSavePdG() {
    if (this.selectData) {
      this.selectData.forEach(x => x.Sorting = 0);
    }

    this.emitList.emit(this.selectData);
    this.modalRef.close();
  }

  onOpenPd(GID) {
    const group = _.find(this.mainDataList, a => a.GroupNo == GID);
    this.showListPd = _.cloneDeep(group.PDList);
    this.PdModalRef = this.dialogService.open(this.PdModal, {});
  }

  onSavePd() {
    const GID = this.showListPd[0].GroupNo;
    const group = _.find(this.mainDataList, a => a.GroupNo == GID);
    _.assign(group.PDList, this.showListPd);
    group.IsOK_Group = _.findIndex(group.PDList, 'IsOK_Product') > -1;
    group.IsOK_Product_Count(this.t('common_confirm_selection', '已選'));

    if (group.PDList) {
      group.PDList.forEach(x => this.AddSelectData(x, x.IsOK_Product));
    }

    this.sumSelect();
    this.PdModalRef.close();
  }

  getProductList(fun) {
    this.info.IsLoding = true;
    this.http.get<any>(`api/ProductSetting/GetAllProductList?` +
      `ORG_Company_ID=${this.query.ORG_Company_ID}` +
      `${this.selectORG_Store_ID != null ? "&CreateStore=" + this.selectORG_Store_ID : ''}` +
      `&Keyword=${this.query.searchKey}` +
      `${this.PRD_PlatformType_ID != null ? "&PRD_PlatformType_ID=" + this.PRD_PlatformType_ID : ''}`
    ).subscribe({
      next: data => {
        this.info.IsLoding = false;
        if (fun) {
          fun(data);
        }
      },
      error: error => {
        console.error('There was an error!', error);
        this.info.IsLoding = false;
      }
    });
  }

  t(key: string, fallback: string): string {
    const text = this.translationService.getText(key);
    return !text || text === key ? fallback : text;
  }

  tt(key: string, fallback: string): string {
    return this.t(key, fallback);
  }
}

class ProductGroup {
  CreateStoreName: string;
  GroupNo: string;
  GroupName: string;
  IsOK_Group: boolean;
  PDList: Product[];
  CountStr: string;
  CountSum: number;

  IsOK_Product_Count(selectedLabel: string) {
    const use = _.filter(this.PDList, 'IsOK_Product').length;
    this.CountStr = use == this.PDList.length ? '全部' : `${selectedLabel}${use}項`;
    this.CountSum = use;
  }
}

class Product {
  GroupNo: string;
  GroupName: string;
  No: string;
  Name: string;
  IsOK_Group: boolean;
  IsOK_Product: boolean;
}

class selectData {
  value: number;
  content: string;
  info: string;
}
